import { createSlice } from "@reduxjs/toolkit";

export const FLOW_TYPE_PERSONAL_ACCIDENT_STANDARD = "FLOW_TYPE_PERSONAL_ACCIDENT_STANDARD";

const initialState = {
    flowType: FLOW_TYPE_PERSONAL_ACCIDENT_STANDARD,
    currentStepIndex: 0,
    currentSubstepIndex: 0,
};

const personalAccidentFlowSlice = createSlice({
    name: "personalAccidentFlow",
    initialState,
    reducers: {
        setFlowType: (state, action) => {
            const data = action.payload;
            state.flowType = data.type;
            state.currentStepIndex = data.currentStepIndex || 0;
            state.currentSubstepIndex = data.currentSubstepIndex || 0;
        },
        setCurrentStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
            state.currentSubstepIndex = 0;
        },
        setCurrentSubstepIndex: (state, action) => {
            state.currentSubstepIndex = action.payload;
        },
        clearPersonalAccidentFlow: () => initialState
    }
});

export const selectPersonalAccidentFlow = (store) => store.personalAccidentFlow;
export const selectPersonalAccidentFlowType = (store) => store?.personalAccidentFlow?.flowType;
export const selectPersonalAccidentCurrentStepIndex = (store) => store?.personalAccidentFlow?.currentStepIndex;
export const selectPersonalAccidentCurrentSubstepIndex = (store) => store.personalAccidentFlow?.currentSubstepIndex;

export const { 
    setFlowType, 
    setCurrentStepIndex, 
    setCurrentSubstepIndex, 
    clearPersonalAccidentFlow 
} = personalAccidentFlowSlice.actions;

export default personalAccidentFlowSlice.reducer;